<template>
	<div class="header">
		<div class="header-logo" @click="goHome()">
			<img src="/svg/garbur_horizontal_black.svg" />
		</div>
		<div :class="showMenu ? 'animation-cont mobile-menu-cont' : ''">
			<div :class="showMenu ? 'nav-sec-responsive animate__animated animate__fadeInDown' : 'nav-sec'" @click="showMenu ? openMenu() : null">
				<router-link class="header5" to="/">Search</router-link>
				<router-link class="header5" to="/about">About</router-link>
				<router-link v-if="isAuthenticated" class="header5" to="/account">Account</router-link>
				<router-link v-if="!isAuthenticated" class="header5" to="/login">Login</router-link>
				<router-link v-if="isAuthenticated" class="header5" to="/logout">Logout</router-link>
			</div>
		</div>

		<div :class="showMenu ? 'icon clicked' : 'icon'" @click="openMenu()">...</div>
	</div>
</template>

<script>
import { AUTH_LOGOUT } from "@/store/constants";

export default {
	name: "Header",
	data() {
		return {
			showMenu: false,
		};
	},
	computed: {
		isAuthenticated: {
			get() {
				return this.$store.getters.isAuthenticated;
			},
		},
		version: {
			get() {
				return process.env.VUE_APP_VERSION;
			},
		},
	},
	methods: {
		goHome() {
			location.href = "https://www.garbur.com";
		},
		openMenu() {
			this.showMenu = !this.showMenu;
		},
	},
};
</script>

<style scoped lang="scss">
.header {
	height: 105px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 0 2rem;
	margin: 0 auto;
	max-width: 1600px;
	.header-logo {
		img {
			height: 40px;
			vertical-align: middle;
			justify-self: flex-start;
			margin-right: auto;
			cursor: pointer;
		}
	}
	.nav-sec {
		display: flex;
		align-items: flex-end;
		justify-content: space-evenly;
		column-gap: 15px;
		a {
			color: var(--black);
			text-decoration: none;
			padding-bottom: 10px;
			&.router-link-exact-active {
				position: relative;
				padding-bottom: 10px;
			}
			&.router-link-exact-active:after {
				content: "";
				background: linear-gradient(148.72deg, #5edede 17.55%, #0616b1 73.04%);
				display: block;
				height: 3px;
				width: 100%;
				position: absolute;
				bottom: 0;
				animation: onSelect 0.25s ease-out;
			}
			@keyframes onSelect {
				from {
					width: 0;
				}
				to {
					width: 100%;
				}
			}
		}
	}
	.icon {
		display: none;
	}
	.nav-sec-responsive {
		display: none;
	}
	// ------
	.slide-enter-active,
	.slide-leave-active {
		transition: transform 0.2s ease;
	}

	.slide-enter,
	.slide-leave-to,
	.slide-leave {
		transform: translateX(-100%);
		transition: all 150ms ease-in 0s;
	}
	// ----
}
@media screen and (max-width: 414px) {
	.header {
		position: relative;
		.nav-sec a {
			display: none;
		}
		.animation-cont {
			width: 100%;
			height: max-content;
			overflow: hidden;
			display: block;
			top: 100%;
			position: absolute;
			right: 0;
		}
		.mobile-menu-cont {
			z-index: 9999;
		}
		.icon {
			float: right;
			display: block;
			right: 10px;
			width: 60px;
			color: var(--accent);
			height: 60px;
			cursor: pointer;
			font-size: 70px;
			line-height: 20px;
			position: absolute;
			-webkit-transition: all 500ms ease;
			-moz-transition: all 500ms ease;
			-ms-transition: all 500ms ease;
			-o-transition: all 500ms ease;
			transition: all 500ms ease;
		}
		.icon.clicked {
			-webkit-transform: rotate(-90deg);
			-moz-transform: rotate(-90deg);
			-ms-transform: rotate(-90deg);
			-o-transform: rotate(-90deg);
			transform: rotate(-90deg);
		}
		.nav-sec-responsive {
			display: block;
			a {
				float: none;
				text-align: left;
				// @ASK
				background: var(--white);
				color: var(--accent);
				color: var(--primary);
				padding: 0 10px;
				height: 40px;
				text-decoration: none;
				width: 95vw;
				// @ASK
				border-bottom: 0.5px solid #32175a;
				align-items: center;
				display: flex;
			}
			a:hover {
				background: #0616b1;
				color: white;
			}
		}
	}
}
</style>
